import { useMutation } from "react-query";
import { getOfcVendorServiceForEdit } from "../../../../actions/CarrierAgreementMgmt/OfficeVendorService";

export const useGetOfcVendorServiceForEdit = () => {
  return useMutation(getOfcVendorServiceForEdit);
};
